import { NextPage } from 'next';
import React from 'react';
import { redirectToNotFound } from 'actions/status';
import type { WavetrakContext } from 'types/wavetrak';

import TravelContainer from '../../containers/TravelContainer';
import TravelLocation from '../../containers/TravelLocation';
import { fetchTravelLocationView } from '../../actions/travelLocationView';
import { fetchTopSpots } from '../../actions/topSpots';
import { getOrCreateStore } from '../../stores';
import isValidGeonameId from '../../utils/isValidGeonameId';

const TravelPage: NextPage = () => (
  <TravelContainer>
    <TravelLocation />
  </TravelContainer>
);

TravelPage.getInitialProps = async (context: WavetrakContext) => {
  const store = getOrCreateStore();
  const { dispatch, getState } = getOrCreateStore();
  const { req, res } = context;
  const cookies = req?.cookies || {};
  const { geonames } = context.query as { geonames: string[] };
  const geonameId = geonames[geonames.length - 1];

  const isServer = !!context.req;

  if (!isValidGeonameId(geonameId)) {
    store.dispatch(redirectToNotFound('The location could not be found'));
    if (isServer && res) {
      res.statusCode = 404;
    }
  } else {
    const preview =
      (Array.isArray(context.query?.preview)
        ? context.query.preview[0]
        : context.query?.preview) === 'true';
    await dispatch(
      fetchTravelLocationView(geonameId, cookies, {
        ...(preview && { preview: true }),
      }),
    );
    const state = getState();
    const hasTravelFailure = !!state.travelLocationView?.error;
    if (hasTravelFailure) {
      dispatch(redirectToNotFound('No travel page found for this location'));
      if (isServer && res) {
        res.statusCode = 404;
      }
    } else {
      await dispatch(fetchTopSpots(geonameId, cookies));
    }
  }

  if (isServer) {
    // eslint-disable-next-line @typescript-eslint/no-require-imports -- dynamic import for server-only newrelic
    const newrelic = require('newrelic');
    newrelic.addCustomAttributes({
      geonames,
    });
    return {
      enableTheme: true,
      enableCssBaseline: true,
      ssrReduxState: getState(),
    };
  }

  return { enableTheme: true, enableCssBaseline: true };
};

export default TravelPage;
